import Vue from 'vue';
import VueAnime from 'vue-animejs'

Vue.use(VueAnime)